import { render, staticRenderFns } from "./DriverMenu.vue?vue&type=template&id=6a1889d0"
import script from "./DriverMenu.vue?vue&type=script&lang=js"
export * from "./DriverMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports